/**
 * SEO Configuration (DealBeez)
 */

import { getSiteName, getSiteUrl } from "./siteConfig";

const siteUrl = getSiteUrl();
const siteName = getSiteName();

const seoConfig = {
  siteName,
  defaultTitle: `${siteName} - Best Coupons & Deals`,
  defaultDescription:
    "Find the best coupons, deals, and discounts from top stores. Save money with verified promo codes.",
  defaultImage: `${siteUrl}/og-image.jpg`,
  defaultKeywords: ["coupons", "deals", "discounts", "promo codes", "savings", "coupon codes"],
  siteUrl,
  twitterHandle: process.env.REACT_APP_TWITTER_HANDLE || "@dealbeez",
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || "",

  titleTemplates: {
    default: `%s | ${siteName}`,
    blog: `%s | ${siteName} Blog`,
    store: `%s Store Coupons | ${siteName}`,
    category: `%s Category Coupons | ${siteName}`,
    coupon: `%s Coupon Code | ${siteName}`,
    deal: `%s Deal | ${siteName}`,
  },

  routes: {
    "/": {
      title: `Home - ${siteName}`,
      description:
        "Find the best coupons and deals from top stores. Save money with verified promo codes and exclusive discounts.",
      keywords: ["coupons", "deals", "discounts", "promo codes"],
      type: "website",
    },
    "/coupons": {
      title: `All Coupons - ${siteName}`,
      description: "Browse all available coupons and promo codes. Find discounts for your favorite stores.",
      keywords: ["coupons", "promo codes", "discount codes"],
      type: "website",
    },
    "/stores": {
      title: `All Stores - ${siteName}`,
      description: "Browse coupons and deals from all our partner stores. Find the best savings.",
      keywords: ["stores", "retailers", "shopping", "coupons"],
      type: "website",
    },
    "/categories": {
      title: `All Categories - ${siteName}`,
      description:
        "Browse coupons and deals by category. Find savings in fashion, electronics, food, and more.",
      keywords: ["categories", "shopping categories", "product categories"],
      type: "website",
    },
    "/blog": {
      title: `Blog - ${siteName}`,
      description: "Read the latest articles about saving money, shopping tips, and exclusive deals.",
      keywords: ["blog", "articles", "shopping tips", "savings tips"],
      type: "website",
    },
    "/about": {
      title: `About Us - ${siteName}`,
      description: `Learn about ${siteName} - your trusted source for coupons, deals, and savings.`,
      keywords: ["about", "company", "mission"],
      type: "website",
    },
    "/contact": {
      title: `Contact Us - ${siteName}`,
      description: `Get in touch with ${siteName}. We're here to help with any questions or concerns.`,
      keywords: ["contact", "support", "help"],
      type: "website",
    },
    "/faq": {
      title: `FAQ - ${siteName}`,
      description: `Frequently asked questions about ${siteName}, coupons, and how to save money.`,
      keywords: ["faq", "questions", "answers", "help"],
      type: "website",
    },
    "/privacy": {
      title: `Privacy Policy - ${siteName}`,
      description: "Read our privacy policy to understand how we collect, use, and protect your information.",
      keywords: ["privacy", "privacy policy", "data protection"],
      type: "website",
    },
    "/terms": {
      title: `Terms of Service - ${siteName}`,
      description: `Read our terms of service to understand the rules and guidelines for using ${siteName}.`,
      keywords: ["terms", "terms of service", "legal"],
      type: "website",
    },
    "/submit-deal": {
      title: `Submit a Deal - ${siteName}`,
      description: `Submit your coupon or deal to ${siteName} and reach thousands of customers.`,
      keywords: ["submit", "coupon submission", "add coupon"],
      type: "website",
    },
  },
};

export default seoConfig;
